export const skillsData = [
  "HTML",
  "Javascript",
  "CSS",
  "React",
  "MongoDB",
  "nodejs",
  "ExpressJS",
];
